import classNames from "classnames";
import { ReactNode } from "react";

interface ClaroNumberedCardProps {
  number: number;
  text: string;
  position?: "top-left" | "top-center" | "top-right";
  className?: string;
  numberClassName?: string;
  textClassName?: string;
  children?: ReactNode;
}

export const ClaroNumberedCard = ({
  number,
  text,
  position = "top-center",
  className,
  numberClassName,
  textClassName,
  children,
}: ClaroNumberedCardProps) => {
  return (
    <div
      className={classNames(
        "w-full h-44 relative flex flex-col items-center justify-center gap-4 bg-white rounded-2xl pb-6 px-6 pt-14",
        {
          "mt-6": position === "top-center",
          "mt-6 ml-6": position === "top-left",
          "mt-6 mr-6": position === "top-right",
        },
        className
      )}
    >
      <div
        className={classNames(
          "absolute flex items-center self justify-center h-16 w-16 p-5 text-center text-3xl font-bold rounded-full bg-[#c71e26] flex-shrink-0",
          {
            "-translate-y-8 top-0": position === "top-center",
            "-translate-x-6 -translate-y-6 top-0 left-0":
              position === "top-left",
            "translate-x-6 -translate-y-6 top-0 right-0":
              position === "top-right",
          },
          numberClassName
        )}
      >
        <span className="text-white">{number}</span>
      </div>
      {children}
      <p
        className={classNames(
          "text-xs lg:text-sm font-semibold text-center",
          textClassName
        )}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
};
